<template>
    <div class="test" :id="'test-' + test.id">
        <div class="table-row test-item" :class="[{active: showDetails}, getTestStatus(test.status)]" @click="openDetails">
            <div class="table-cell date-cell">{{ this.test.date }}</div>
            <div class="table-cell status-cell">
                <Tooltip :text="getTestStatus(test.status) === 'neutral' ? 'Автор відкликав свій відгук' : ''">
                    <div class="test-status " :class="getTestStatus(test.status)">
                        <icon-test class="color-success" v-if="test.status === 1 || test.status === 2"/>
                        <icon-test class="icon-link" v-else-if="test.status === 3  || test.status === 0"/>
                        {{ getTestStatusLabel(test.status)}}
                    </div>
                </Tooltip>
            </div>
            <div class="table-cell author-cell">
                <TestersList :testers="allTesters" :info="test" :is-mobile="isMobile" is-big="true"
                             :position="isMobile ? 'right': 'center'"/>
                <p class="author-cell-test-count" v-if="childTests">Кількість тестів: {{ childTests.length + 1 }}</p>
            </div>
            <div class="table-cell comments-cell">
                <div>
                    <div class="md-up-hidden test-subtitle">Коментарі</div>
                    <div class="comments-cell-content">
                        <icon-comments/>
                        ({{test.comments ? test.comments.length : 0}})
                    </div>
                </div>
            </div>
            <div class="table-cell conclusion-cell">
                <div class="conclusion-text in-table" v-if="test.conclusion">
                    <div class="md-up-hidden test-subtitle">Висновок</div>
                    <span v-html="test.conclusion"></span>
                </div>
            </div>
            <div class="test-toggle cursor-pointer">
                <span class="md-up-hidden">{{ showDetails ? 'Згорнути' : 'Детальніше' }}</span>
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"
                     :class="{active: showDetails}">
                    <path
                        d="M15.435 6.32486L9.49992 12.1104L3.5648 6.32486C3.45876 6.22128 3.3164 6.1633 3.16817 6.1633C3.01994 6.1633 2.87759 6.22128 2.77155 6.32486C2.7202 6.37517 2.67941 6.43521 2.65157 6.50148C2.62372 6.56775 2.60937 6.63891 2.60938 6.7108C2.60937 6.78268 2.62372 6.85384 2.65157 6.92011C2.67941 6.98638 2.7202 7.04643 2.77155 7.09673L9.08549 13.2527C9.19637 13.3608 9.34508 13.4213 9.49992 13.4213C9.65476 13.4213 9.80348 13.3608 9.91436 13.2527L16.2283 7.09792C16.28 7.04758 16.3211 6.98738 16.3492 6.92089C16.3772 6.8544 16.3917 6.78297 16.3917 6.7108C16.3917 6.63863 16.3772 6.56719 16.3492 6.5007C16.3211 6.43421 16.28 6.37402 16.2283 6.32367C16.1223 6.2201 15.9799 6.16211 15.8317 6.16211C15.6834 6.16211 15.5411 6.2201 15.435 6.32367V6.32486Z"
                        fill="currentcolor"/>
                </svg>
            </div>
        </div>
        <transition name="slide">
            <div class="test-details" :class="getTestStatus(test.resolution)" v-if="showDetails">
                <div class="test-details-block">
                    <div class="test-authors-list">
                        <TestAuthorExpanded v-for="(org, index) in allTesters" :info="org" :key="index"/>
                    </div>
                    <TestItemContent :test="test" @opencslider="openSlider" @updatelikes="updateLikes"/>
                    <button class=" btn btn-outline toggle-child-tests" :class="{active: showChildTests}" @click="showChildTests = !showChildTests" v-if="childTests && childTests.length">
                        <span v-if="!showChildTests">Показати</span>
                        <span v-if="showChildTests">Згорнути</span> попередні відгуки ({{ childTests.length }})
                        <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.2365 0.233411L5.49952 4.85096L0.762546 0.233411C0.677912 0.150744 0.564298 0.104463 0.44599 0.104463C0.327682 0.104463 0.214068 0.150744 0.129434 0.233411C0.0884543 0.273562 0.0558984 0.321487 0.0336731 0.374379C0.0114478 0.42727 0 0.484065 0 0.541437C0 0.598808 0.0114478 0.655603 0.0336731 0.708494C0.0558984 0.761386 0.0884543 0.809311 0.129434 0.849463L5.16874 5.76272C5.25724 5.84898 5.37593 5.89726 5.49952 5.89726C5.6231 5.89726 5.74179 5.84898 5.83029 5.76272L10.8696 0.850411C10.9109 0.810229 10.9437 0.762186 10.9661 0.709119C10.9885 0.656052 11 0.599037 11 0.541437C11 0.483837 10.9885 0.426821 10.9661 0.373754C10.9437 0.320687 10.9109 0.272644 10.8696 0.232463C10.785 0.149796 10.6713 0.103516 10.553 0.103516C10.4347 0.103516 10.3211 0.149796 10.2365 0.232463V0.233411Z" fill="currentcolor"/>
                        </svg>
                    </button>
                    <transition name="fade" v-if="childTests">
                        <div v-if="showChildTests">
                            <div v-for="(test, index) in childTests" :key="index">
                                <div class="child-test-head" :class="getTestStatus(test.status)">
                                    <div class="test-status" :class="getTestStatus(test.status)">
                                        {{ test.resolution }}
                                    </div>
                                    <div class="child-test-head-date">{{ test.date }}</div>
                                </div>
                                <TestItemContent :test="test" @opencslider="openSlider" @updatelikes="updateLikes"/>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import IconDate from '../icons/IconDate';
import IconDiagram from '../icons/IconDiagram';
import IconComments from '../icons/IconComments';
import IconPhoto from '../icons/IconPhoto';
import IconNote from '../icons/IconNote';
import IconTest from '../icons/IconTest';
import IconTypeText from '../icons/IconTypeText';
import IconTypeVideo from '../icons/IconTypeVideo';
import AuthorTooltip from '../AuthorTooltip';
import TestAuthor from '../TestAuthor';
import Tooltip from '../Tooltip';
import TestAuthorExpanded from '../TestAuthorExpanded';
import TestItemContent from "./TestItemContent";
import IconLike from '../icons/IconLike';
import IconDisLike from '../icons/IconDisLike';
import IconInfo from '../icons/IconInfo';
import TestersList from '../TestersList';
import IconWarning from '../icons/IconWarning';

export default {
    name: "TestItem",
    components: {
        IconWarning,
        TestersList,
        IconInfo,
        IconDisLike,
        IconLike,
        TestItemContent,
        TestAuthorExpanded,
        Tooltip,
        TestAuthor,
        AuthorTooltip, IconTypeVideo, IconTypeText, IconNote, IconPhoto, IconComments, IconDiagram, IconDate, IconTest
    },
    props: ['test', 'isMobile', 'childTests', 'setOpen'],
    data() {
        return {
            detailsOpen: false,
            showChildTests: false,
            ignoreSetOpen: false
        }
    },
    methods: {
        updateLikes(value) {
            this.$emit('updatelikes', value)
        },
        openDetails() {
            this.ignoreSetOpen = true;
            this.detailsOpen = !this.detailsOpen;
            if (this.detailsOpen) {
                window.location.hash = this.test.id;
            } else {
                history.pushState('', document.title, window.location.pathname);
            }
        },
        openSlider(photos, start) {
            this.$emit('opencslider', photos, start);
        },
        getTestStatus(status){
            if(status === 0) {
                return 'neutral'
            } else if (status === 1 || status === 2) {
                return 'positive'
            } else {
                return 'neutral'
            }
        },
        getTestStatusLabel(status){
            if(status === 0 || status === 1 || status === 2) {
                return 'Актуальний'
            } else if(status === 3) {
                return 'Відкликаний'
            }
        }
    },
    computed: {
        showDetails() {
            return this.ignoreSetOpen ? this.detailsOpen : this.setOpen;
        },
        humanDate() {
            const months = [
                'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
            ]
            const dateArr = this.test.date.split('.');
            const month = months[dateArr[1].replace('0', '') - 1];
            return `${dateArr[0]} ${month} ${dateArr[2]} року`
        },
        allTesters() {
            return this.test.experts.concat(this.test.organizations)
        },
    }
}
</script>
<style lang="scss">

@import "../../../../sass/front/helpers";

.author-cell {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    &-test-count {
        color: #DADADA;
        font-size: 11px;
        font-weight: 300;
        line-height: 160%;
    }
}

.toggle-child-tests {
    width: 100%;
    background-color: #fff;
    color: $color-brand;
    border-radius: 6px;
    font-family: "Ukraine";

    svg {
        transition: transform .3s;
        margin-left: 10px;
    }

    &.active svg {
        transform: rotate(180deg);
    }
}

.child-test-head {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    margin: 15px 0;

    &-date {
        font-weight: 700;
        margin: 0 15px;
    }

    &:after {
        content: "";
        display: block;
        height: 1px;
        flex: 1;
    }

    &.positive:after {
        background-color: #1AC819;
    }

    &.negative:after {
        background-color: #CB0000;
    }

    &.neutral:after {
        background-color: #e9ebef;
    }
}

.test {
    position: relative;
    border-bottom: solid 1px #EEEEEE;

    &:nth-child(odd) {
        background-color: #fbfbfb;
    }

    @include responsive-below($sm) {
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 8px;
    }

    &-item {
        cursor: pointer;

        @media (hover: hover) {
            &:hover {
                position: relative;

                &:before {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 3px;
                    background: linear-gradient(156.9deg, #437AFC 20.78%, #F8E42F 100%);
                }
            }
        }

        &:hover,
        &.active {
            background-color: #FBFBFC;
        }
        @media (hover: hover) {
            &:hover {
                .test-toggle {
                    background-color: $color-brand;
                    color: #fff;
                }
            }
        }
    }

    &-status {
        display: flex;
        gap: 6px;
        align-items: center;
        border-radius: 7px;
        padding: 0 10px;
        height: 42px;
        font-weight: 500;
        font-size: 11px;
        line-height: 1;

        &.negative {
            background-color: #ffebeb;
        }

        &.neutral {
            background-color: #F3F3F3;
        }

        &.positive  {
            background-color: #ecffec;
        }
    }

    &-details {
        background: #FBFBFC;
        border-radius: 0 0 8px 8px;
        border-top: solid 1px #dddddd;
        position: relative;

        &-wrap {
            padding-left: 12px;
        }

        &-block {
            padding: 2rem 40rem 2rem 25rem;

            @include responsive-below($lg) {
                padding: 2rem 35rem 2rem 2rem;
            }

            @include responsive-below($sm) {
                padding: 2rem 1.6rem 2rem 1.6rem;
            }

            @include responsive-below($xs) {
                padding: 2rem 1rem 2rem 1rem;
            }

            @include responsive-below($xxs) {
                padding: 2rem 0 2rem 0;
            }
        }

        .conclusion-text {
            line-height: 25px;

            p {
                font-weight: 300;
                margin-bottom: 14px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            ol, ul {
                margin-bottom: 14px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            &.recall-text {
                background: #F8F8F8;
                border: 1px solid #FFD964;
                border-radius: 8px;
                color: #959595;
                padding: 10px 18px;

                @include responsive-below($xs) {
                    padding: 6px 12px;
                }
            }
        }

        &.positive {
            border-color: #1AC819
        }

        &.negative {
            border-color: #CB0000
        }

        &-item {
            border-left: 2px solid #E9EBEF;
            padding: 0 2.5rem 4.6rem;
            position: relative;

            @include responsive-below($sm) {
                padding: 0 .5rem 4rem 2.4rem;
            }

            &:last-child {
                padding-bottom: 1rem;
                border-left: 0;
            }
        }

        &-icon {
            background: #779DF7;
            color: #fff;
            border-radius: 22px;
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 8px #FBFBFC;
            position: absolute;
            left: -22px;
            top: -10px;

            &.bg-warning {
                background: #F4D975;
            }
        }

        &-content {
            &-controls {
                gap: 0.8rem;
            }

            &.-first {
                display: flex;

                @include responsive-above($md) {
                    justify-content: space-between;
                    align-items: center;
                    transform: translateY(-5px);
                }

                @include responsive-below($md) {
                    flex-direction: column;
                    gap: 1rem;
                }
            }
        }

        &-title {
            font-weight: 500;
            font-size: 14px;
            margin-bottom: 10px;
        }

        &-photos {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            cursor: pointer;

            @include responsive-below($sm) {
                gap: 3px;
            }
        }

        &-photo {
            border: 1px solid #EEEEEE;
            border-radius: 0.9rem;
            height: 9rem;

            @include responsive-below($sm) {
                height: 6.5rem;
            }
        }

        &-videos {
            display: flex;
            flex-wrap: wrap;
            margin: -0.2rem -24rem 0.8rem -0.4rem;

            @include responsive-below($sm) {
                margin: -0.2rem -0.2rem 1rem;
            }
        }

        &-video {
            flex: 0 0 33.333%;
            max-width: 33.333%;
            padding: 0.4rem;
            margin-bottom: 1.2rem;

            @include responsive-below($sm) {
                padding: 0.2rem;
            }

            @include responsive-below($xs) {
                flex-basis: 50%;
                max-width: 50%;
            }
        }

        &-addition {
            margin-bottom: 1.2rem;

            &-item {
                display: flex;
                align-items: center;
                gap: 10px;
                color: #434A51;
                text-decoration: none;
                transition: color 0.3s;

                &:hover {
                    color: #4578EB;
                }
            }
        }

        &-content {
            &-item {
                margin-top: 15px;
            }
        }

        &-link {
            color: #94A3B8;
            font-size: 12px;
            text-decoration: none;

            & > svg {
                margin-left: 5px;
                vertical-align: -2px;
            }

            &:hover {
                color: $color-brand;
            }
        }
    }

    &-subtitle {
        font-weight: 500;
        margin-bottom: 4px;
        font-style: normal;
        color: #252525;
    }

    &-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        min-width: 42px;
        height: 42px;
        border-radius: 50%;
        background: #F8F8F8;
        margin-right: 10px;

        &:hover {
            opacity: 0.7;
        }

        @include responsive-below($md) {
            position: static;
            width: 100%;
            height: 30px;
            font-size: 11px;
            gap: 7px;
            border-radius: 7px;
            order: 3;
            margin-bottom: 14px;
            transform: none;
            margin-top: 12px;
        }

        svg {
            transition: transform 0.3s;

            &.active {
                transform: rotate(180deg);
            }
        }
    }
}

.text-warning {
    color: #F4D975;
}

.conclusion-text {
    font-weight: 300;
    color: rgba(70, 79, 96, 0.8);
    font-size: 14px;

    &.in-table {
        padding-right: 70px;

        @include responsive-below($sm) {
            padding-right: 0;
        }
    }
}
.testers-list {
    display: flex;
    align-items: center;

    @include responsive-below($sm){
        padding-right: 20px;
    }

    &-item {
        margin-right: -20px;
        display: flex;
        align-items: center;
        position: relative;

        .author {
            margin-right: 0;
        }
    }
}

.test-authors-list {
    position: absolute;
    right: 18px;

    & > div {
        margin-bottom: 4px;
    }

    @include responsive-below($sm) {
        display: none;
    }
}

.slide-enter-active {
    transition-duration: 0.3s;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
    max-height: 1000px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>

